export default __webpack_public_path__ + "static/media/w_f_2023_h.41bf68cd.jpeg";